<template>
  <el-dialog width="550px" :visible.sync="visible" title="安全验证" @close="close">
    <!-- 主体内容 -->
    <el-form label-width="100px">
      <el-form-item label="手机号:">
        <span>{{ verifyInfo.phoneNumber }}</span>
      </el-form-item>

      <el-form-item label="验证码:">
        <div class="authentication-container">
          <el-input-digit v-model.number="verifyCode" placeholder="填写验证码" :precision="0" style="width: 150px" />
          <el-button :disabled="isLock" @click="getVerificationCode">{{ phoneVerifyCodeText }}</el-button>
        </div>
      </el-form-item>
    </el-form>

    <!-- tips -->
    <div class="tips-container">
      <p>说明：</p>
      <p>
        1、为了有效保障商家/消费者数据安全，以下平台：淘系（淘宝/天猫/1688/淘宝特价版/天猫供销）平台订单其他数据导出时，增加二次短信验证导出。
      </p>
      <p>2、短信验证一天只需验证1次</p>
    </div>

    <!-- 按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sendVerifyCodeDownloadCenter } from '@api/trade/downloadCenter.js';

export default {
  name: 'AuthenticationDialog',
  computed: {
    phoneVerifyCodeText() {
      if (!this.isLock) {
        return '获取验证码';
      }
      return `已发送(${this.countdown})秒`;
    },
  },
  data() {
    return {
      visible: false,
      isLock: false, // 锁
      verifyCode: '', // 验证码
      countdown: 60, // 倒计时
      timer: null, // 定时器

      verifyInfo: {},
    };
  },
  methods: {
    // 获取验证码
    async getVerificationCode() {
      // 开启锁之后不再走当前方法
      if (this.isLock) {
        return;
      }

      this.isLock = true;
      this.runCountdown();
      await sendVerifyCodeDownloadCenter({ phoneNumber: this.verifyInfo.phoneNumber });
    },
    resetDefault() {
      this.countdown = 60;
      this.isLock = false;
      clearInterval(this.timer);
      this.timer = null;
    },
    // 开启倒计时
    runCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.resetDefault();
        }
        this.countdown--;
      }, 1000);

      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.timer);
      });
    },
    // 打开弹框
    show(info) {
      this.verifyCode = '';
      this.visible = true;
      this.verifyInfo = info;
    },
    // 关闭弹框
    close() {
      this.visible = false;
    },
    async onSubmit() {
      if (this.verifyCode === '') {
        this.$message.warning('请输入验证码');
        return;
      }

      this.$emit('on-success', {
        verifyCode: this.verifyCode,
        phoneNumber: this.verifyInfo.phoneNumber,
      });
    },
    success() {
      this.close();
      this.resetDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  min-height: 80px !important;
}
.authentication-container {
  .el-button {
    width: 110px;
    padding: 6px;
    margin-left: 10px;
  }
}
.verify-code-info {
  text-align: left;
  margin-left: 24px;
  margin-top: 10px;
  font-size: 12px;
  color: green;
}
.authentication-btn-container {
  text-align: center;
  .el-button {
    width: 270px;
    padding: 8px 0;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
.tips-container {
  p {
    margin: 0;
    font-size: 12px;
    &:nth-child(1) {
      color: red;
      margin-top: 20px;
    }
    &:nth-child(2) {
      text-indent: 2em;
      color: red;
      margin-bottom: 5px;
    }
    &:nth-child(3) {
      text-indent: 2em;
      color: red;
    }
  }
}
</style>
